import { CardMode } from './card'

export interface ActivitiesProps {
    activities: ActivityProps[]
    loading: boolean
    filters?: ActivitiesFiltersProps
    totalPages: number
    activePage: number
    showContent: boolean
    hideSidebar: boolean
    setActivePage: (page: number) => void
    openActivity: (a: any) => void
}

export interface ActivityProps {
    id: string
    title: string
    time: string
    dueTime: string
    type: ActivityType
    sourceModule: ActivityModule
    isMostUrgent: boolean
    status: ProjectStatus
    isRead: boolean
    priority: ProjectPriority
    mode?: CardMode
    hasBorderColor?: boolean
    timeZone?: string
    onClick?: () => void
}

export enum ActivityModule {
    COMMUNICATION = 'communication',
    VISIT = 'visit',
    NEWS = 'news',
    SVT = 'svt',
}

export enum ActivityType {
    REMINDER = 'reminder',
    REACTION = 'reaction',
    EVENT_GENERIC = 'event_generic',
    EVENT_WITH_TASK = 'event_with_task',
}

export enum ProjectPriority {
    NORMAL = 'normal',
    HIGH = 'high', // deprecated
    URGENT = 'urgent',
}
export enum ProjectStatus {
    DRAFT = 'draft',
    RELEASED = 'RELEASED',
    REJECTED = 'rejected',
    NEW = 'new',
    READ = 'read',
    IN_PROGRESS = 'inProgress',
    PRE_CLOSED = 'preClosed',
    IN_APPROVAL = 'inApproval',
    REDO = 'redo',
    CLOSED = 'closed',
    OVERDUE = 'overdue',
    CANCELLED = 'cancelled',
    TO_BE_RELEASED = 'toBeReleased',
    RECALLED = 'recalled'
}

export enum ACTIVITY_TYPE {
    COMMUNICATION = 'COMMUNICATION',
    VISIT = 'VISIT',
}

export interface ActivitiesFiltersProps {
    page: number
    page_size: number
    tab?: 'to_me' | 'from_me' | 'others'
    type?: ActivitiesFiltersObjectProps
    status?: ActivitiesFiltersObjectProps
    priority?: ActivitiesFiltersObjectProps
    start_date?: ActivitiesFiltersObjectProps
    end_date?: ActivitiesFiltersObjectProps
    more_information?: boolean
    useIntervalDate?: boolean
}

export interface ActivitiesFiltersObjectProps {
    value: string | string[] | number | Date
    orderBy?: 'DESC' | 'ASC'
    hours?: number
    minutes?: number
    seconds?: number
}

export interface ActivitiesHeaderProps {
    activities: ActivityProps[]
    showContent: boolean
    setShowContent: (showContent: boolean) => void
}
